/**
 * @ngdoc directive
 * @name shopline
 *
 * @description
 * Line containing one product detail
 */
module.directive('shopline', function () {
    'use strict';
    return {
        restrict: 'E',
        scope: {
            product: '=content'
        },
        controller: ['$scope', '$rootScope', 'cart', function ($scope, $rootScope, $cart) {

            $scope.configSite = $rootScope.config.site;

            $scope.membershipYear = new Date().getFullYear();

            $scope.addToCart = function (product) {
                if (!product.pending) {
                    product.pending = true;
                    $cart.addProduct(product).then(function () {
                        product.pending = false;
                    });
                }
            };
        }],
        templateUrl: 'src/components/shopline/shopline.html'
    };
});
